export const themes = {
  admin_clinique: {
    primary: "#388E3C", // Couleur plus foncée que #43A047
    secondary: "#F1F8E9",
    accent: "#A5D6A7",
    text: "#37474F",
    icon: "#388E3C", // Optionnel : foncez aussi l'icône pour l'harmoniser
  },
  // Ajoutez ici d'autres thèmes si besoin
};

export const menuConfigs = {
  admin_clinique: [
    { label: "Tableau de Bord", path: "" },
    { label: "Gestion du Personnel", path: "personnel" },
    { label: "Consultations", path: "consultation" },
  ],
  agent_clinique: [
    { label: "Accueil", path: "" },
    { label: "Reception", path: "Reception" },
    /* { label: 'Rendez-vous', path: 'rendez-vous' },*/
  ],
  medecin_clinique: [
    { label: "Reception", path: "reception" },
    { label: "Prescriptions", path: "prescription" },
    { label: "Patients", path: "patients" },
  ],
  admin_pharmacie: [
    { label: "Tableau de Bord", path: "" },
    { label: "Gestion du Personnel", path: "personnel" },
    { label: "Prescriptions", path: "prescriptions" },
  ],
  agent_pharmacie: [
    { label: "Accueil", path: "" },
    { label: "Prescriptions", path: "prescriptions" },
  ],
  admin_laboratoire: [
    { label: "Tableau de Bord", path: "" },
    { label: "Gestion du Personnel", path: "personnel" },
    { label: "Prescriptions", path: "prescriptions" },
    { label: "Résultats", path: "resultats" },
  ],
  agent_laboratoire: [
    { label: "Accueil", path: "" },
    { label: "Prescriptions", path: "prescriptions" },
    { label: "Résultats", path: "resultats" },
  ],
};

export const userMenuConfigs = {
  admin_clinique: [
    { label: "Mon Profil", path: "profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  agent_clinique: [
    { label: "Mon Profil", path: "/clinique/profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  medecin_clinique: [
    { label: "Mon Profil", path: "/profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  admin_pharmacie: [
    { label: "Mon Profil", path: "profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  agent_pharmacie: [
    { label: "Mon Profil", path: "profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  admin_laboratoire: [
    { label: "Mon Profil", path: "profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  agent_laboratoire: [
    { label: "Mon Profil", path: "profile" },
    { label: "Paramètres", path: "/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
  assurance: [
    { label: "Mon Profil", path: "/assurance/profile" },
    { label: "Paramètres", path: "/assurance/settings" },
    { label: "Déconnexion", path: "/logout" },
  ],
};

export const getTitle = (userRole, fallback = "Clinique") => {
  switch (userRole) {
    case "admin_pharmacie":
    case "agent_pharmacie":
      return "Pharmacie";
    case "admin_laboratoire":
    case "agent_laboratoire":
      return "Laboratoire";
    default:
      return fallback;
  }
};
